import usePreventClickOnDrag from '@activities/MainActivity/components/MainBanners/hooks/usePreventClickOnDrag';
import styles from '@activities/MainActivity/components/MainBanners/styles.module.scss';
import Checkbox from '@components/Checkbox';
import Indicator from '@components/Indicator';
import PopupBanner from '@components/PopupBanners/PopupBanner';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import {
  Fragment, useEffect, useRef, useState,
} from 'react';
import { useCookies } from 'react-cookie';
import Slider from 'react-slick';

import usePopupBanners from './hooks/usePopupBanners';

function PopupBanners() {
  const { banners } = usePopupBanners();
  const [cookies, setCookies, removeCookies] = useCookies(['hidePopupBanners']);
  const [isHide, setIsHide] = useState<boolean>(cookies.hidePopupBanners || false);
  const [isNone, setIsNone] = useState<boolean>(false);
  const [index, setIndex] = useState<number>(0);
  const { beforeChange, afterChange } = usePreventClickOnDrag();
  const hide = () => {
    setIsHide(true);
  };
  const hideToday = () => {
    if (cookies.hidePopupBanners) {
      removeCookies('hidePopupBanners');
    } else {
      setCookies('hidePopupBanners', 'true', { path: '/', maxAge: 60 * 60 * 24 });
    }
  };
  const sliderRef = useRef<Slider>(null);
  useEffect(() => {
    if (isHide) {
      const timeout = setTimeout(() => {
        setIsNone(true);
      }, 350);
      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [isHide]);
  useEffect(() => {
    const interval = setInterval(() => {
      sliderRef.current?.slickNext();
    }, 2000);
    return () => clearInterval(interval);
  }, []);
  if (banners && banners?.length !== 0) {
    return (
          <Dim isHide={isHide}
               isNone={isNone}>
              <Container isHide={isHide}>
                {banners.length === 1 ? (
                    <PopupBanner banner={banners![0]}/>
                ) : (
                    <Slider dots={false}
                            ref={sliderRef}
                            className={styles.slider}
                            beforeChange={beforeChange}
                            afterChange={(newIndex) => {
                              setIndex(newIndex);
                              afterChange();
                            }}>
                        {banners?.map((banner) => (
                            <PopupBanner banner={banner}
                                         key={banner.imageUrl}/>
                        ))}
                    </Slider>
                )}

                {(banners?.length || 0) > 1 && (
                    <IndicatorWrapper>
                      <Indicator total={banners?.length || 0}
                                 current={index} />
                    </IndicatorWrapper>
                )}
                <Footer>
                    <TodayDisable>
                        <Checkbox isChecked={cookies.hidePopupBanners}
                                  onClick={hideToday} >
                            <Text fontWeight='bold'>
                                오늘 하루 보지 않기
                            </Text>
                        </Checkbox>
                    </TodayDisable>
                  <Close onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    hide();
                  }}>
                      <Text fontWeight='bold'>
                          닫기
                      </Text>
                  </Close>
                </Footer>
              </Container>
          </Dim>
    );
  }
  return (<Fragment/>);
}

const Footer = styled.footer`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${colors.white};
    width: 100%;
    border-top: 1px solid ${colors.gray3};
    padding-bottom: var(--safe-area-bottom);
`;

const Dim = styled.div<{
  isHide: boolean;
  isNone: boolean;
}>`
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.65);
    display: ${(props) => (props.isNone ? 'none' : 'flex')};
    flex-direction: column;
    justify-content: flex-end;
    transition: 350ms;
    opacity: ${(props) => (props.isHide ? 0 : 1)};
`;

const Container = styled.div<{isHide: boolean}>`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: 350ms;
  transform: translateY(${(props) => (props.isHide ? '100%' : '0')});
    border-radius: 16px 16px 0 0;
    overflow: hidden;
`;

const IndicatorWrapper = styled.div`
  position: absolute;
  bottom: calc(72px + var(--safe-area-bottom));
`;

const TodayDisable = styled.div`
    padding:  20px;
    flex: 1;
    border-right: 1px solid ${colors.gray3};
`;

const Close = styled.div`
    padding:  20px;
`;

export default PopupBanners;
